const scriptId = 'meta-data-one-news';

export function createOneNewsMicroMarking(oneNews) {
  const container = getTagRobots()

  const value = {
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": document.href
    },
    "headline": oneNews.title,
    "image": [
      oneNews.post_image_webp,
    ],
    "datePublished": oneNews.created_at,
    "dateModified": oneNews.updated_at,
    "author": {
      "@type": "Person",
      "name": "Jobian"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Jobian",
      "logo": {
        "@type": "ImageObject",
        "url": "https://api.jobian.com/storage/settings/October2020/7XvjKx3mH4LFRlKIRTds.webp"
      }
    },
    "description": oneNews.excerpt
  };

  container.innerHTML = JSON.stringify(value)
}

export function deleteOneNewsMicroMarking() {
  const tag = document.getElementById(scriptId)
  tag?.remove();
}

function getTagRobots() {
  return document.getElementById(scriptId) || createTag()
}

function createTag() {
  const tag = document.createElement('script')
  tag.setAttribute('type', 'application/ld+json')
  tag.setAttribute('id', scriptId)
  document.head.appendChild(tag)
  return tag
}

